// Per-user, per-room device order override, cached in localStorage.
//
// Why: the room device list is a merge of the room query (has SortOrder) and the
// full device list (no SortOrder, used to surface DeviceIDs the room query hides,
// e.g. WWRGB/door/curtain). Those merged-in devices can't read their SortOrder
// back, so a reorder wouldn't stick. This cache makes reordering reliable for
// EVERY device type immediately (we still write backend SortOrder too, so a
// future backend that returns it for all devices stays consistent).

const key = (userId, roomId) => `sli_devorder_${userId}_${roomId}`;

export function saveDeviceOrder(userId, roomId, unos) {
  try { localStorage.setItem(key(userId, roomId), JSON.stringify(unos.map(String))); } catch (e) { /* ignore */ }
}

export function applyDeviceOrder(userId, roomId, devices, unoOf) {
  try {
    const raw = localStorage.getItem(key(userId, roomId));
    if (!raw) return devices;
    const order = JSON.parse(raw);
    const rank = new Map(order.map((u, i) => [String(u), i]));
    // Stable sort by saved rank; anything not in the saved order keeps its place after.
    return devices
      .map((d, i) => ({ d, i }))
      .sort((a, b) => {
        const ra = rank.has(String(unoOf(a.d))) ? rank.get(String(unoOf(a.d))) : 100000 + a.i;
        const rb = rank.has(String(unoOf(b.d))) ? rank.get(String(unoOf(b.d))) : 100000 + b.i;
        return ra - rb;
      })
      .map((x) => x.d);
  } catch (e) {
    return devices;
  }
}
